import { useState } from "react";

const useModalResponse = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState(null);
  const [messageStatus, setMessageStatus] = useState(null)
  const [submessageStatus, setSubmessageStatus] = useState(null)

  const openModal = (status) => {
    setModalStatus(status);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalStatus(null);
  };

  return {
    isModalOpen,
    closeModal,
    setModalOpen,
    openModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    submessageStatus,
    setSubmessageStatus
  };
};

export default useModalResponse;